import { render, staticRenderFns } from "./common-click-tupu.vue?vue&type=template&id=da5803e4&scoped=true&"
import script from "./common-click-tupu.vue?vue&type=script&lang=ts&"
export * from "./common-click-tupu.vue?vue&type=script&lang=ts&"
import style0 from "./common-click-tupu.vue?vue&type=style&index=0&id=da5803e4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da5803e4",
  null
  
)

export default component.exports